export type LogoSlotId = 'jobListingLogo' | 'fullLogo';

export type LogoShapeConstraint = 'square' | 'square-or-rectangular';

export const ACCEPTED_LOGO_MIME_TYPES = ['image/jpeg', 'image/png', 'image/jpg'] as const;

export type AcceptedLogoMimeType = typeof ACCEPTED_LOGO_MIME_TYPES[number];

export const MAX_LOGO_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const SQUARE_LOGO_MIN_DIMENSION_PX = 300;
export const SQUARE_LOGO_MAX_DIMENSION_PX = 1000;
export const SQUARE_LOGO_PREFERRED_DIMENSION_PX = 700;

export interface ImageFileMeta {
  file: File;
  sizeBytes: number;
  mimeType: string;
  widthPx: number;
  heightPx: number;
}

export interface LogoValidationResult {
  isValid: boolean;
  errors: string[];
}

export interface LogoSlotConfig {
  id: LogoSlotId;
  title: string;
  description: string;
  shapeConstraint: LogoShapeConstraint;
  isSquare: boolean;
  previewHref?: string;
}
